import * as React from "react";
import { useContext } from "react";
import "maplibre-gl/dist/maplibre-gl.css";
import GeometryVectorTileLayer from "./GeometryVectorTileLayer";
import DataLayer from "./DataLayer";
import LabelLayer from "./LabelLayer";
import MarkerLayers from "./MarkerLayers";
import { AppContext } from "../context/AppContext";
import ProtectedAreas from "./ProtectedAreas";
import Legend from "./Legend";
import BackgroundServices from "./BackgroundServices";
import GlöZ2Areas from "./GLöZ2Areas";
import NUT2Areas from "./NUT2Areas";
import ActivePointLayer from "./ActivePointLayer";

export default function Layers() {
  const appContext = useContext(AppContext);

  return (
    <>
      <MarkerLayers />
      <ActivePointLayer />
      {appContext.markerLayersReady && (
        <>
         <BackgroundServices />        
          <GeometryVectorTileLayer />
          <DataLayer />
          <LabelLayer />
          <ProtectedAreas />
          <GlöZ2Areas />  
          <NUT2Areas />
          <Legend />
        </>
      )}
    </>
  );
}
